/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {GameInterface} from '@/store/modules/games/types';

const namespace: string = 'gamesStateModule';

/**
 * GamesNavigation component.
 *
 */

@Component({
    name: 'c-games-navigation',
})
export default class GamesNavigation extends Vue {
    // Games
    @Action('fetchGames', {namespace})
    public fetchGames: any;
    @Action('updateCurrentGame', {namespace})
    public updateCurrentGame: any;
    @Getter('getCurrentGame', {namespace})
    public getCurrentGame!: GameInterface;
    @Getter('getGames', {namespace})
    public getGames!: GameInterface[];
    // Settings masthead
    @Action('updateMastheadImage', {namespace: 'settingsModule'})
    public updateMastheadImage!: (imageSlug: string | undefined) => void;


    /**
     * Mounted life-cycle event.
     */
     public async mounted(): Promise<void> {
         await this.fetchGames();
    }

    /**
     * Select a game
     *
     * @param game
     */
    public selectGame(game: GameInterface): void {
        this.$router.push({name: 'reported-issues-game-slug', params: {gameSlug: game.slug}});
        this.updateCurrentGame(game);
        this.updateMastheadImage(game.key_art);
    }
}
